module.exports = __webpack_public_path__ + "img/folder-plus.4c7b5f72.svg";